<template lang="html">
    <div>
        <div class="form-group d-flex">

            <div class="col-sm-12">
                <label>Name<span class="color-6">*</span></label>
                <div class="d-flex align-items-center">
                    <input type="text" class="w-50" v-model="reason.description" placeholder="Description here" @input="descriptionIsReadyToSave($event)" />
                </div>
				<div class="mt-2">
					<label>Cancelation Reason Type</label>
					<div class="d-flex align-items-center">
						<v-select label="name" v-model="reasonTypeObject" :reduce="name => name.id" @input="reason.reasonType = reasonTypeObject.id" :options="reasonTypesOptions"></v-select>
					</div>
				</div>
            </div>

        </div>
    </div>
</template>

<script>
import extendedVSelect from '@/extends/vue-select'
import { mapActions, mapGetters} from 'vuex'

export default {
	data(){
		return {
			reasonTypeObject: this.reasonTypesOptions[0], // default
		}
	},
    props:{
        reason:{
            type: Object
        },
		reasonTypesOptions: {
			type: Array,
		}
    },
	mounted(){
		if(this.reason && this.reason.reasonType){
			this.reasonTypeObject = this.reasonTypesOptions.find((reasonTypeObject) => reasonTypeObject.id === this.reason.reasonType)
		}
	},
    computed:{
        ...mapGetters([
        ]),
    },
    methods: {
        ...mapActions([
            'closeModal',
        ]),
		descriptionIsReadyToSave: function(event){
			this.$emit('canSaveReason', event.target.value)
			return !!event.data
		},
    },
    components:{
        vSelect: extendedVSelect
    }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// cancellationReasonsForm.vue?4f5da909